<template>
  <div>

    <Molded>
      <b-row>
        <b-col
          cols="12"
          lg="3"
        >
          <RadioGroup
            title="Faturar para outro Cliente?"
            :options="[
                        { text: 'Sim', value: true },
                        { text: 'Não', value: false },
                    ]"
            v-model="generateNfse.otherCustomer"
          />
        </b-col>
        <b-col
          cols="12"
          lg="9"
          v-if="generateNfse.otherCustomer"
        >
          <CustomerWithCreate v-model="generateNfse.customer" />
        </b-col>
      </b-row>
    </Molded>

    <br />

    <div v-if="loadingConfig">
      <Loading
        type="line"
        :center="true"
      />
    </div>

    <div v-else>
      <div v-if="isNacional">

        <b-tabs>
          <b-tab title="Dados">
            <NacionalDados
              formName="nfseFromRentNacional"
              :disabled="false"
              :showCustomer="false"
              :showLocacao="false"
              :showValor="false"
              v-model="nacionalDados"
            />
          </b-tab>
          <b-tab title="Regime Tributário">
            <NacionalRegimeTributario
              :disabled="false"
              :ehSimplesNacional="ehSimplesNacional"
              v-model="nacionalRegimeTributario"
            />
          </b-tab>
          <b-tab title="Impostos">
            <NacionalImposto
              formName="nfseFromRentNacional"
              :disabled="false"
              :ehSimplesNacional="ehSimplesNacional"
              v-model="nacionalImposto"
            />
          </b-tab>
          <b-tab title="Totalização de Impostos">
            <NacionalTransparencia
              :disabled="false"
              :ehSimplesNacional="ehSimplesNacional"
              v-model="nacionalTransparencia"
            />
          </b-tab>
        </b-tabs>
        <br />
        <b-tabs v-if="mostrarAbaLocalEvento">
          <b-tab title="Local do Evento">
            <NfseLocalEvento
              :disabled="false"
              :rentId="nacionalDados && nacionalDados.locacao ? nacionalDados.locacao.id : $route.params.rentId"
              v-model="nacionalLocalEvento"
            />
          </b-tab>
        </b-tabs>
      </div>

      <div v-else>
        <b-tabs>
          <b-tab title="Dados">
            <PrefeituraDados
              formName="nfseFromRentPrefeitura"
              :disabled="false"
              :showCustomer="false"
              :showLocacao="false"
              :showValor="false"
              v-model="prefeituraDados"
            />
          </b-tab>
          <b-tab title="Regime Tributário">
            <PrefeituraRegimeTributario
              :disabled="false"
              v-model="prefeituraRegimeTributario"
            />
          </b-tab>
          <b-tab title="Impostos">
            <PrefeituraImposto
              formName="nfseFromRentPrefeitura"
              :disabled="false"
              :dados="prefeituraDados"
              v-model="prefeituraImposto"
            />
          </b-tab>
          <b-tab title="Totalização de Impostos">
            <PrefeituraTransparencia
              :disabled="false"
              v-model="prefeituraTransparencia"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import CustomerWithCreate from "../../rental/shared/CustomerWithCreate.vue";

import NacionalDados from "../../tax-document/nfse-nacional/Dados.vue";
import NacionalImposto from "../../tax-document/nfse-nacional/Imposto.vue";
import NfseNacional from "../../tax-document/nfse-nacional/NfseNacional.js";
import NacionalRegimeTributario from "../../tax-document/nfse-nacional/RegimeTributario.vue";
import NacionalTransparencia from "../../tax-document/nfse-nacional/Transparencia.vue";

import PrefeituraDados from "../../tax-document/nfse-prefeitura/Dados.vue";
import PrefeituraImposto from "../../tax-document/nfse-prefeitura/Imposto.vue";
import NfsePrefeitura from "../../tax-document/nfse-prefeitura/NfsePrefeitura.js";
import PrefeituraRegimeTributario from "../../tax-document/nfse-prefeitura/RegimeTributario.vue";
import PrefeituraTransparencia from "../../tax-document/nfse-prefeitura/Transparencia.vue";

import NfseLocalEvento from "../../tax-document/nfse-shared/NfseLocalEvento.vue";

import { mapActions } from "vuex";

export default {
  name: "NewGenerateNfse",
  props: ["customerId", "value"],
  components: {
    Molded,
    RadioGroup,
    CustomerWithCreate,
    Loading,
    NacionalDados,
    NacionalImposto,
    NacionalTransparencia,
    NacionalRegimeTributario,
    PrefeituraDados,
    PrefeituraImposto,
    PrefeituraTransparencia,
    PrefeituraRegimeTributario,
    NfseLocalEvento,
  },
  data() {
    const modelNacional = new NfseNacional();
    const modelPrefeitura = new NfsePrefeitura();

    return {
      urlGetConfigCompanyById: "/api/v1/tax-document/config-company/get-by-id",
      urlGetTaxationById: "/api/v1/tax-document/taxation/get-by-id",
      loadingConfig: true,
      isNacional: true,
      ehSimplesNacional: false,
      mostrarAbaLocalEvento: false,
      loadingTaxationValidation: false,
      taxationValidationRequestId: 0,

      generateNfse: {
        otherCustomer: false,
        customer: {},
        nacional: true,
        nfsePrefeitura: NfsePrefeitura.createObj({
          dados: modelPrefeitura.dados,
          regimeTributario: modelPrefeitura.regimeTributario,
          imposto: modelPrefeitura.imposto,
          transparencia: modelPrefeitura.transparencia,
        }),
        nfseNacional: NfseNacional.createObj(
          {
            dados: modelNacional.dados,
            regimeTributario: modelNacional.regimeTributario,
            imposto: modelNacional.imposto,
            transparencia: modelNacional.transparencia,
            localEvento: modelNacional.localEvento,
          },
          false
        ),
      },

      nacionalDados: null,
      nacionalRegimeTributario: null,
      nacionalImposto: null,
      nacionalTransparencia: null,
      nacionalLocalEvento: null,

      prefeituraDados: null,
      prefeituraRegimeTributario: null,
      prefeituraImposto: null,
      prefeituraTransparencia: null,
    };
  },
  mounted() {
    this.$emit("input", this.generateNfse);
    this.getConfigCompany();
  },
  computed: {},
  methods: {
    ...mapActions("generic", ["getApi"]),
    limparLocalEventoComNull() {
      this.nacionalLocalEvento = {
        codigoEvento: null,
        nomeEvento: null,
        dataInicioEvento: null,
        dataFimEvento: null,
        cepEvento: null,
        logradouroEvento: null,
        numeroEvento: null,
        complementoEvento: null,
        bairroEvento: null,
      };
    },
    validarServicoParaLocalEvento(servicoId) {
      if (!servicoId) {
        this.mostrarAbaLocalEvento = false;
        this.limparLocalEventoComNull();
        this.montarGenerateNfseTributacao();
        return;
      }

      this.loadingTaxationValidation = true;
      const requestId = ++this.taxationValidationRequestId;
      const params = { url: this.urlGetTaxationById, obj: { id: servicoId } };

      this.getApi(params)
        .then((response) => {
          if (requestId !== this.taxationValidationRequestId) return;

          const taxation = response?.content || {};
          const codigo = String(
            taxation.Codigo ?? taxation.codigo ?? taxation.code ?? ""
          );
          const exibirLocalEvento = codigo.startsWith("12");

          this.mostrarAbaLocalEvento = exibirLocalEvento;

          if (!exibirLocalEvento) {
            this.limparLocalEventoComNull();
            this.montarGenerateNfseTributacao();
          }
        })
        .catch(() => {
          if (requestId !== this.taxationValidationRequestId) return;

          this.mostrarAbaLocalEvento = false;
          this.limparLocalEventoComNull();
          this.montarGenerateNfseTributacao();
        })
        .finally(() => {
          if (requestId !== this.taxationValidationRequestId) return;
          this.loadingTaxationValidation = false;
        });
    },
    getConfigCompany() {
      const params = { url: this.urlGetConfigCompanyById, obj: {} };
      this.getApi(params)
        .then((response) => {
          if (response && response.success && response.content) {
            const data = response.content;
            this.isNacional = !!data.nacional;
            this.generateNfse.nacional = this.isNacional;
            this.ehSimplesNacional = !!data.simplesNacional;
            this.montarGenerateNfseTributacao();
          }
        })
        .finally(() => {
          this.loadingConfig = false;
        });
    },
    montarGenerateNfseAPartirDosDados() {
      if (this.isNacional && this.nacionalDados) {
        this.generateNfse.customer = this.nacionalDados.tomador || {};
      }

      if (!this.isNacional && this.prefeituraDados) {
        this.generateNfse.customer = this.prefeituraDados.tomador || {};
      }
    },
    montarGenerateNfseTributacao() {
      this.generateNfse.nacional = this.isNacional;

      this.generateNfse.nfseNacional = this.buildNfseNacionalPayload();
      this.generateNfse.nfsePrefeitura = this.buildNfsePrefeituraPayload();
    },
    buildNfseNacionalPayload() {
      const model = new NfseNacional();

      const nfseNacional = {
        dados: this.isNacional
          ? this.nacionalDados || model.dados
          : model.dados,
        regimeTributario: this.isNacional
          ? this.nacionalRegimeTributario || model.regimeTributario
          : model.regimeTributario,
        imposto: this.isNacional
          ? this.nacionalImposto || model.imposto
          : model.imposto,
        transparencia: this.isNacional
          ? this.nacionalTransparencia || model.transparencia
          : model.transparencia,
        localEvento: this.isNacional
          ? this.nacionalLocalEvento || model.localEvento
          : model.localEvento,
      };

      return NfseNacional.createObj(nfseNacional, this.ehSimplesNacional);
    },
    buildNfsePrefeituraPayload() {
      const modelPref = new NfsePrefeitura();

      const nfsePrefeitura = {
        dados: !this.isNacional
          ? this.prefeituraDados || modelPref.dados
          : modelPref.dados,
        regimeTributario: !this.isNacional
          ? this.prefeituraRegimeTributario || modelPref.regimeTributario
          : modelPref.regimeTributario,
        imposto: !this.isNacional
          ? this.prefeituraImposto || modelPref.imposto
          : modelPref.imposto,
        transparencia: !this.isNacional
          ? this.prefeituraTransparencia || modelPref.transparencia
          : modelPref.transparencia,
      };

      return NfsePrefeitura.createObj(nfsePrefeitura);
    },
  },
  watch: {
    generateNfse: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
    nacionalDados: {
      handler() {
        this.montarGenerateNfseAPartirDosDados();
        this.montarGenerateNfseTributacao();
      },
      deep: true,
    },
    nacionalRegimeTributario: {
      handler() {
        this.montarGenerateNfseTributacao();
      },
      deep: true,
    },
    nacionalImposto: {
      handler() {
        this.montarGenerateNfseTributacao();
      },
      deep: true,
    },
    nacionalTransparencia: {
      handler() {
        this.montarGenerateNfseTributacao();
      },
      deep: true,
    },
    nacionalLocalEvento: {
      handler() {
        this.montarGenerateNfseTributacao();
      },
      deep: true,
    },
    "nacionalDados.servico.id": {
      handler(servicoId) {
        this.validarServicoParaLocalEvento(servicoId);
      },
      immediate: true,
    },

    prefeituraDados: {
      handler() {
        this.montarGenerateNfseAPartirDosDados();
        this.montarGenerateNfseTributacao();
      },
      deep: true,
    },
    prefeituraRegimeTributario: {
      handler() {
        this.montarGenerateNfseTributacao();
      },
      deep: true,
    },
    prefeituraImposto: {
      handler() {
        this.montarGenerateNfseTributacao();
      },
      deep: true,
    },
    prefeituraTransparencia: {
      handler() {
        this.montarGenerateNfseTributacao();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.div-title {
  font-size: 16px;
  margin-left: 5px;
  margin-bottom: 20px;
}
</style>